import http from '@/services/http'
import type * as Types from './type'
import { convertCurrency } from '@yy/one-currency'
import { businessTimezoneTranslate } from '../businessTimezone'

/** 是否可以创建退货单 */
export const vaildCanCreateRefundOrder = (refundMcId: string) =>
  http.admin.takeLatest<Types.CanCreateOrderRes>('vaildCanCreateRefundOrder', 'post', '/api/refund/can-create-order', {
    refundMcId,
  })

/** 创建退货单 */
export const postRefundCreate = (data: Types.RefundCreateReq) => {
  const finalData = convertCurrency(data).centify(['details.[].price', 'details.[].subDetails.[].price' as any])
  return http.admin.post('/api/refund/create', finalData)
}

/** 编辑退货单 */
export const postRefundUpdate = (data: Types.RefundUpdateReq) => {
  const PRICE_KEY = ['addDetails.[].price', 'addDetails.[].subDetails.[].price', 'updateDetails.[].price', 'updateDetails.[].subDetails.[].price']
  const finalData = convertCurrency(data).centify(PRICE_KEY as any)
  return http.admin.post('/api/refund/update', finalData)
}

/** 退货单详情 */
export const postRefundDetail = (refundOrderId: string, containsProduct?: boolean) => http.admin.post<Types.RefundGetRes>('/api/refund/get', { refundOrderId, containsProduct })

/** 退货单运费计算 */
export const postCalculateRefundFreight = (params: Types.CalculateFreightReq) => http.admin.post<Types.CalculateFreightRes>('/api/refund/calculate-freight', params)

/** 执行退货 */
export const executeRefund = (data: Types.RefundBatchReqDTO) => http.admin.post('/api/refund/batch-refund', data, { toast: true })

/** 作废退货单 */
export const cancelRefund = (data: Types.RefundBatchReqDTO) => http.admin.post('/api/refund/batch-cancel', data, { toast: true })

/** 取消作废 */
export const cancelCancelledRefund = (data: Types.RefundBatchReqDTO) => http.admin.post('/api/refund/batch-recover', data, { toast: true })

/** 拦截退货 */
export const interceptRefund = (data: Types.RefundBatchReqDTO) => http.admin.post('/api/refund/batch-intercept', data, { toast: true })

/** 完成退货 */
export const completeRefund = (data: Types.RefundBatchReqDTO) => http.admin.post('/api/refund/batch-mark-complete', data, { toast: true })

/** 轨迹 */
export function getRefundTraceGet(data: Types.RefundGetReqDTO) {
  return http.admin.get<Types.TraceRes>(`/api/refund/track/list`, { params: data })
}

/** 批量更新仓库 */

export const batchUpdateWarehouse = (data: Types.RefundBatchUpdateWarehouseReqDTO) => http.toast.post('/api/refund/batch-update-warehouse', data)

/**
 * **接口** [出库单转换成退货单数据](https://apidoc.inshopline.com/#/project/Java/80/feature%2F2971_gift/interface/1a1a71e5a8270199a4ee87b3f08b8fb7)
 * @请求头 `POST /api/refund/convert`
 * @更新时间 `2024-06-19 18:23:18`
 */
export function postConvert(data?: Types.RefundConvertReqDTO) {
  return http.admin.post<Types.ConvertRes>(`/api/refund/convert`, data)
}

/**
 * **接口** [退货单转换↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F2971_gift/interface/bddee994bef9bd3c11a7aa8e7690e39e)
 * @请求头 `POST /api/refund/convert-details`
 * @更新时间 `2024-06-20 11:58:09`
 */
export function postConvertDetails(data?: { refundOrderId: string }) {
  return http.admin.post<Pick<Types.ConvertRes, 'details' | 'hasGroupSkuDelete' | 'hasSubSkuNotMatch'>>(`/api/refund/convert-details`, data)
}

export const refundSearch = businessTimezoneTranslate(
  (params) => http.admin.post<Types.RefundSearchRes>('/api/refund/search', params),
  ['createEndTime', 'createStartTime'],
  ['data.list.[].createTime']
)
